import { rest } from 'msw'
export default [
  /**
   * OGP情報
   */
  rest.post('/api/v2/get_ogtag', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          responseTime: '1562309754',
          tags: [
            {
              url:
                'https://www.kurashiru.com/recipes/3054c237-178b-4ba7-9a1b-2fd327d5a2a7',
              og: {
                site_name: 'クラシル',
                type: 'food',
                title:
                  'まいたけチーズクリームソースのチキンステーキ 作り方・レシピ | クラシル',
                description:
                  '「まいたけチーズクリームソースのチキンステーキ」の作り方を簡単で分かりやすい料理動画で紹介しています。まいたけが入ったチーズクリームソースのチキンステーキはいかがでしょうか。鶏むね肉はまいたけと一緒に冷蔵庫で寝かせる事で柔らかくなります。淡白な鶏むね肉に濃厚なチーズクリームソースがよく合います。是非お試しください。',
                url:
                  'https://www.kurashiru.com/recipes/3054c237-178b-4ba7-9a1b-2fd327d5a2a7',
                image: {
                  url:
                    'https://static.retailstudio.jp/assets/contents/538/thumbnail_d839b2fbaba2d27cdb7f2b4fe32b3d30.jpg',
                  type: 'image/jpg',
                  height: '800',
                  width: '800',
                },
                video: {
                  url:
                    'https://video.kurashiru.com/production/videos/3054c237-178b-4ba7-9a1b-2fd327d5a2a7/original.mp4',
                  type: 'video/mp4',
                  height: '800',
                  width: '800',
                },
              },
            },
            {
              url:
                'https://www.kurashiru.com/recipes/08dcadab-ae46-4e24-a1b9-ccae48fcf1c3',
              og: {
                site_name: 'クラシル',
                type: 'food',
                title:
                  '鶏むね肉の しっとり柔らかしょうが焼き 作り方・レシピ | クラシル',
                description:
                  '「鶏むね肉の しっとり柔らかしょうが焼き」の作り方を簡単で分かりやすい料理動画で紹介しています。リーズナブルな鶏むね肉のしょうが焼きはいかがでしょうか。淡泊な鶏むね肉にしっかりと味付けをすることで味わい豊かになり、さっぱりとお召し上がりいただけますよ。とても簡単に作れますので是非お試しくださいね。',
                url:
                  'https://www.kurashiru.com/recipes/08dcadab-ae46-4e24-a1b9-ccae48fcf1c3',
                image: {
                  url:
                    'https://video.kurashiru.com/production/videos/08dcadab-ae46-4e24-a1b9-ccae48fcf1c3/compressed_thumbnail_square_large.jpg?1517474840',
                  type: 'image/jpg',
                  height: '800',
                  width: '800',
                },
                video: {
                  url:
                    'https://video.kurashiru.com/production/videos/08dcadab-ae46-4e24-a1b9-ccae48fcf1c3/original.mp4',
                  type: 'video/mp4',
                  height: '800',
                  width: '800',
                },
              },
            },
            {
              url:
                'https://www.kurashiru.com/recipes/38c0cab4-99d7-4e20-b8a1-43bcc96208c7',
              og: {
                site_name: 'クラシル',
                type: 'food',
                title: '鶏むね肉のしそチーズ挟み焼き 作り方・レシピ | クラシル',
                description:
                  '「鶏むね肉のしそチーズ挟み焼き」の作り方を簡単で分かりやすい料理動画で紹介しています。おかず、お弁当、おつまみにも活躍間違いなし！ご飯やビールがすすむ一品です。甘めのタレで、お子様も喜ぶ味付けです。ご自宅にある食材で簡単に作ることができます。調理時間も短いので、忙しい時にも役立つはず！ぜひ作ってみてくださいね。',
                url:
                  'https://www.kurashiru.com/recipes/38c0cab4-99d7-4e20-b8a1-43bcc96208c7',
                image: {
                  url:
                    'https://video.kurashiru.com/production/videos/38c0cab4-99d7-4e20-b8a1-43bcc96208c7/compressed_thumbnail_square_large.jpg?1502272526',
                  type: 'image/jpg',
                  height: '800',
                  width: '800',
                },
                video: {
                  url:
                    'https://video.kurashiru.com/production/videos/38c0cab4-99d7-4e20-b8a1-43bcc96208c7/original.mp4',
                  type: 'video/mp4',
                  height: '800',
                  width: '800',
                },
              },
            },
          ],
        },
      })
    )
  }),
]
